<template>
    <div class="section-h">
        <h2 class="is-size-3 is-uppercase is-underlined">All League</h2>
        <div class="push-top push-extra">
            <div class="endpoint flex-center" v-for="(sport, idx) in sports" :key="idx">
                <router-link class="is-uppercase is-size-5 has-text-white has-text-centered" :to="{ name: 'certificate-detail', params: { sport }}">
                    {{sport}}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import Certificates from '@/components/Certificates.js';

export default {
  name: 'certificate-list',
  data() {
    return {
      sports: Certificates.List.map(c => c.title).sort()
    };
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/helpers.scss';

.endpoint {
  padding: 0.75em;
  &:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.2);
  }
}
</style>

